import React, { useEffect, useState } from 'react'
import useTrans from '@hooks/useTrans'
import { LogStatoPosizionePersonalizzazioneOrdineType, PosizionePersonalizzazioneType, UserType } from '@utils/types'
import { cn, dateTimeFormat } from '@utils/safeTs'
import { StatoOrdine, Modal, FormCheckbox } from '@components/atoms'
import styles from './MyAccountStatusLogModal.module.sass'


interface Props {
  id: string
  posizione: PosizionePersonalizzazioneType
  open: boolean
  onClose: () => void
  userType: UserType
  className?: string
}

const MyAccountStatusLogModal = (props: Props) => {

  const { 
    id,
    posizione,
    open,
    onClose,
    userType,
    className = '',
  } = props

  const t = useTrans()
  const [mostraOriginali, setMostraOriginali] = useState(false)
  useEffect(() => setMostraOriginali(false), [open, posizione.id])

  const cols = [
    { key: 'dataora', label: t("Data/ora"), render: (item: LogStatoPosizionePersonalizzazioneOrdineType) => dateTimeFormat(item.created) },
    { key: 'stato', label: t("Stato"), render: (item: LogStatoPosizionePersonalizzazioneOrdineType) => <StatoOrdine level={'posizione'} stato={item.stato} userType={userType} /> },
    { key: 'nota', label: t("Nota"), render: (item: LogStatoPosizionePersonalizzazioneOrdineType) => mostraOriginali ? item.note : item.noteTradotta || item.note },
  ]

  return (
    <Modal 
      id={id}
      title={t("Cronologia posizione")}
      subtitle={[posizione.personalizzazione?.nomeLavorazione, posizione.posizione?.nome].filter(Boolean).join(" - ")}      
      open={open}
      onClose={onClose}
      className={cn(styles.root, className)}
      headerClassName={styles.header}
    >
      {posizione.log?.some(log => log.noteTradotta && log.noteTradotta !== log.note) && (
        <FormCheckbox
          id={`status-log-modal-traduzioni-${posizione.id}`}
          size="sm"
          label={
            <>
              {t('Mostra testi originali')}
              {' — '}
              {t('Traduzione automatica generata da IA')}
            </>
          }
          checked={mostraOriginali}
          onChange={(event) => setMostraOriginali(event.target.checked)}
          className={styles.translationToggle}
        />
      )}
      <div className={styles.table}>
        <div className={styles.tableHead}>
          {cols.map(col => (
            <div key={col.key} className={cn(styles.tableHeadCell, styles[`tableHeadCell--${col.key}`])}>
              {col.label}
            </div>
          ))}
        </div>
        <div className={styles.tableBody}>
          {posizione.log?.length ? (
            [...posizione.log].sort((a, b) => a.created > b.created ? -1 : 1).map(log => (
              <div key={log.id} className={styles.tableRow}>
                {cols.map(col => (
                  <div key={col.key} className={cn(styles.tableCell, styles[`tableCell--${col.key}`])}>
                    {col.render(log)}
                  </div>
                ))}
              </div>
            ))
          ) : (
            <div className={styles.empty}>
              {t("Nessun log presente")}
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default MyAccountStatusLogModal
